import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import { getLockedByOthersDataActionHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import { lockedByOthers } from "../../../../utils/mainTabs/social/lockedByOthers";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";

const LockByOthers = () => {
  const pageSize = 8;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantName } = useOutletContext();
  const [tableColumns, setTableColumns] = useState([]);
  const { searchPlaceHolder } = lockedByOthers;
  const { columns } = moderateContributions;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getLockedByOthersDataActionHandler, pageSize);

  useEffect(() => {
    let newTableColumns = columns(
      location,
      navigate,
      dispatch,
      handleSearchQuery,
      tenantName
    );
    setTableColumns(newTableColumns);
  }, [columns, location, dispatch, navigate, tenantName]);

  return (
    <DataTable
      columns={tableColumns}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"ID"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default LockByOthers;
